(() => {
    function openUrl(url, openInNewTab) {
        window.open(url, openInNewTab === 'true' ? '_blank' : '_self', 'noopener');
    }
    
    function handleKeyPress(event, url, openInNewTab) {
        if (event.key === 'Enter' || event.key === ' ') {
            openUrl(url, openInNewTab);
        }
    }
    
    if (!window.componentJSInitialized) {
        window.componentJSInitialized = true;
        document.addEventListener("DOMContentLoaded", () => {
            const banners = document.getElementsByClassName('mag-banner');
            Array.from(banners).forEach(element => {
                element.addEventListener('click', () => openUrl(element.dataset.bannerlink, element.dataset.newtab));
                element.addEventListener('keydown', (event) => handleKeyPress(event, element.dataset.bannerlink, element.dataset.newtab));
            });
        })
    }
})()
